export interface IntegrationState<T = any> {
  entity?: T;
  selectedEntitiesIds?: string[];
}

export function integrationStateDefault(): IntegrationState {
  return {
    selectedEntitiesIds: []
  };
}
